import { render } from "./summary.vue?vue&type=template&id=a0af67b4&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"

import "./summary.vue?vue&type=style&index=0&id=a0af67b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0af67b4"]])

export default __exports__